import type { MODULATORS_APPLIANCES_TABLE_CARD_FRENCH_LOCALE } from "~ui/@application/locales/modules/components/modulators-appliances-table-card/modulators-appliances-table-card.fr.ts";

export const MODULATORS_APPLIANCES_TABLE_CARD_ENGLISH_LOCALE = {
  title: "Modulator linked appliances",
  globalSearchPlaceholder: "Search a value...",
  empty: "No appliance found...",
  headers: {
    way: "Way",
    csId: "Cs Id",
    hwId: "Hw Id",
    applianceType: "Appliance type",
    localisation: "Location",
    actions: "Actions",
  },
  editDialog: {
    title: "Edit appliance",
    applianceType: "Appliance type",
    applianceTypePlaceholder: "Select an appliance type",
    localisation: "Location",
    save: "Save",
    cancel: "Cancel",
  },
} satisfies typeof MODULATORS_APPLIANCES_TABLE_CARD_FRENCH_LOCALE;
